/*=============================================== Header styles ===============================================*/

import styled from "styled-components/macro"
import { Link } from "react-router-dom"
import {
    Transitions,
    Breakpoints,
    Mixins,
    Spacers,
    Shadows,
    Burger,
} from "tsx-library-julseb"

export const Logo = styled(Link)`
    color: ${({ theme }) => theme.ColorsHoverDefault({ $color: "white" })};
    transition: ${Transitions.Short};
    text-decoration: none;

    @media ${Breakpoints.Hover} {
        &:hover {
            color: ${({ theme }) =>
                theme.ColorsHoverHover({ $color: "white" })};
        }

        &:active {
            color: ${({ theme }) =>
                theme.ColorsHoverActive({ $color: "white" })};
        }
    }
`

export const StyledHeader = styled.header`
    background-color: ${({ theme }) => theme.Primary800};
    padding: ${Spacers.M} ${Spacers.L};
    color: ${({ theme }) => theme.White};
    z-index: 900;
    position: fixed;
    box-shadow: ${Shadows.M};
    width: 100vw;
    ${Mixins.Flexbox({
        $alignItems: "center",
        $justifyContent: "space-between",
    })}

    &.modal-open {
        z-index: 10;
    }

    &[data-theme="dark"] {
        background-color: ${({ theme }) => theme.Primary100};
        color: ${({ theme }) => theme.Primary500};

        ${Logo} {
            color: ${({ theme }) =>
                theme.ColorsHoverDefault({ $color: "primary" })};

            @media ${Breakpoints.Hover} {
                &:hover {
                    color: ${({ theme }) =>
                        theme.ColorsHoverHover({ $color: "primary" })};
                }

                &:active {
                    color: ${({ theme }) =>
                        theme.ColorsHoverActive({ $color: "primary" })};
                }
            }
        }
    }
`

export const Nav = styled.nav`
    ${Mixins.Flexbox({
        $alignItems: "center",
        $gap: "s",
    })}
    background-color: ${({ theme }) => theme.Primary800};

    &[data-theme="dark"] {
        background-color: ${({ theme }) => theme.Primary100};
        color: ${({ theme }) => theme.Primary500};
    }

    @media ${Breakpoints.Mobile} {
        position: fixed;
        top: -32px;
        left: 0;
        width: 100vw;
        padding: 0 ${Spacers.L};
        z-index: 899;
        transition: ${Transitions.Short};

        &.open {
            top: 56px;
        }
    }
`

export const StyledBurger = styled(Burger)`
    display: none;

    @media ${Breakpoints.Mobile} {
        display: inherit;
    }
`
